export default {
  category: {
    label: 'Category:',
    default: 'All products',
  },
  cart: {
    title_noproductsincart: 'You have no products in your cart.',
    cta_goback: 'Go back to product list',
    title_cart: 'Cart:',
    title_totalamount: 'Total:',
    title_discountedamount: 'Discounted amount',
    title_coupon: 'Coupon',
    coupon_cta_apply: 'Apply',
    coupon_placeholder: 'Coupon',
    cta_remove_product: 'Remove',
    warning_empty: 'Please add a product to your cart.',
    item: 'item | items',
    in_your_cart: 'In Your Cart'
  },
  checkout: {
    title_back: 'Back',
    title_back_description: 'Go back to product listing page.',
    total: 'Total',
    shipping: 'Shipping'
  },
  errors: {
    license: 'License error.',
    unexpected: 'Unexpected error.'
  },
  footer: {
    banner: 'Sell on your own website with <a href="{link}" target="_blank">{name}</a>.'
  },
  form: {
    error_blank: 'The field {field} can not be empty',
  },
  license: {
    expired: 'Your license has expired. Please renew your license.',
    close_button: 'Close'
  },
  list: {
    title_mobile_helper: 'Mobile view',
    description_mobile_helper: 'Tab here to open in a new window.',
    sale_closed: 'Sale Closed'
  },
  modifiers: {
    unselect: 'Unselect'
  },
  order_status: {
    title: 'Payment Status',
    description: 'Your payment is being processed. Please remain at this page without closing it until the status resolves.',
  },
  payment_list: {
    title_partial: 'Pay only partial amount.',
    title_installations: 'Installations:',

    option_installment: '{installment} * {currency} with a total of {total}',
    title_paysecurely: 'Pay securely',
    title_securepayment: 'Your payments are secured with 256-bit military grade encryption.',

    info_emptycart: 'Your cart is empty. Add a product to make a payment.'
  },
  product: {
    title_selection: 'Product selection:',
    title_price: 'Price:',
    cta_addtocart: 'Add to cart at {price}',
    title_amountselection: 'Amount of selection:',
    title_closedforsale: 'This product is not on sale.',
    cta_checkoutpage: 'Go to checkout',

    title_slider_next: 'Next ▶',
    title_slider_previous: '◀ Prev',

    description: 'Description',
    more_info: 'Aditional Information',
    more: 'show more',
    less: 'show less '
  },
  result: {
    title_order_id: 'Order ID',
  },
  sort: {
    label: 'Sort by:',
    default: 'Default',
    price_asc: 'Price ascending',
    price_desc: 'Price descending'
  },
  summary: {
    title: 'Card Summary',
    title_total: 'Total:',
    coupon_cta_apply: 'Apply',
    coupon_placeholder: 'Coupon',
    coupon_cta_remove: 'Remove'
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js